import { render, staticRenderFns } from "./FxSpot.vue?vue&type=template&id=1dc77a69"
import script from "./FxSpot.vue?vue&type=script&lang=js"
export * from "./FxSpot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports